export default __webpack_public_path__ + "static/media/na.efe38969.png";